/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as NormalTimeActions from '../actions/normal-time';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { LOAD_STATES } from './common';

const reducer = createReducer(InitialState.workingHours, (builder) => {
  builder.addCase(UIActions.logout.type, () => ({ ...InitialState.workingHours }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.workingHours }));

  builder.addCase(NormalTimeActions.saveNormalTime.pending, state => ({
    ...state,
    loadState: LOAD_STATES.initial
  }));

  builder.addCase(NormalTimeActions.saveNormalTime.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(NormalTimeActions.saveNormalTime.fulfilled, (state, action) => {
    const workingHours: { [day: string]: number } = { ...state.savedHours };
    if (action.payload) {
      action.payload.forEach(day => (workingHours[day.day] = day.hoursWorked));
    }
    return {
      ...state,
      loadState: LOAD_STATES.done,
      savedHours: workingHours
    };
  });

  builder.addCase(NormalTimeActions.listNormalTime.fulfilled, (state, action) => {
    const workingHours: { [day: string]: number } = { ...state.savedHours };
    if (action.payload) {
      action.payload.forEach(day => (workingHours[day.day] = day.hoursWorked));
    }
    return {
      ...state,
      savedHours: workingHours
    };
  });
});

export default reducer;
